import { useEffect, useState } from 'react';
import { isSsr } from '../utils';
import { useIsClientSide } from './Media.utils';
function useIsMediaQueries(queries) {
  const isClientSide = useIsClientSide();
  const [isMatch, setIsMatch] = useState(() => {
    if (isSsr()) {
      return [false, false];
    }
    const secondQuery = queries[1] ? window.matchMedia(queries[1]).matches : false;
    return [window.matchMedia(queries[0]).matches, secondQuery];
  });
  const [queryFrom, queryTo] = queries;
  useEffect(() => {
    const queryMedia = window.matchMedia(queryFrom);
    const queryCustomMedia = queryTo ? window.matchMedia(queryTo) : null;
    function handleChangeCustom(event) {
      setIsMatch(previousState => [previousState[0], event.matches]);
    }
    function handleChangeMobile(event) {
      setIsMatch(previousState => [event.matches, previousState[0]]);
    }
    queryMedia.addEventListener('change', handleChangeMobile);
    queryCustomMedia?.addEventListener('change', handleChangeCustom);
    return () => {
      queryMedia.removeEventListener('change', handleChangeMobile);
      queryCustomMedia?.removeEventListener('change', handleChangeCustom);
    };
  }, [queryFrom, queryTo]);
  return isClientSide ? isMatch : [false, false];
}
export { useIsMediaQueries };